import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Component/css/PaymentSuccess.css";

function PaymentSuccess() {
  const navigate = useNavigate();

  // 🔥 step control (processing → success)
  const [step, setStep] = useState("processing");

  useEffect(() => {
    // ⏳ 2 sec → show success tick
    const timer1 = setTimeout(() => {
      setStep("success");
    }, 2000);

    // ⏳ 3 sec → redirect
    const timer2 = setTimeout(() => {
      const paymentUser =
        JSON.parse(localStorage.getItem("paymentUser")) ||
        JSON.parse(localStorage.getItem("auth")) ||
        {};

      const returnTo =
        paymentUser.role === "candidate"
          ? "/profile"
          : paymentUser.role === "employer"
            ? "/emp-profile"
            : paymentUser.role === "resume_download"
              ? "/candidate"
              : paymentUser.role === "employer_staff"
                ? "/staff"
                : paymentUser.role === "job_notification"
                  ? "/job"
                  : "/signin";

      navigate(returnTo);
    }, 3000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [navigate]);

  return (
    <div className="hl-success-wrapper">
      <div className="hl-success-card">
        <div className="hl-success-header">
          {/* 🔥 ICON ANIMATION */}
          <div className={`hl-success-icon ${step}`}>
            {step === "processing" && "₹"}
            {step === "success" && "✓"}
          </div>

          <h3>Payment Successful</h3>
          <p>You will be redirected automatically...</p>
        </div>

        <div className="hl-success-countdown">
          {step === "processing"
            ? "Processing payment..."
            : "Payment confirmed ✔"}
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
